import '../../../../styles/oa.scss';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { ListView,PullToRefresh} from 'antd-mobile';
import SearchWrapper from '@/components/searchWrapper';
import Filter from '@/components/filter';
import { MyContext } from '@/utils/contextManager';
import moment from 'moment';
import { kqEmployeeList } from '../../../../services/saas/oa';
import { getUser } from '../../../../utils';

function ListWrap(props) {
  return  <div className="oatb-list">
            <div className="oatb-list-label">
              <span className="oatb-list-label-span">员工姓名</span>
              <span className="oatb-list-label-span">日期</span>
              <span className="oatb-list-label-span">状态</span>
            </div>
            <div className="oatb-list-box">
                {props.children}
            </div>
          </div>
}


function KqEmployeeList(props) {
  const pageSize = 20;
  let [pageIndex, setIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draging, setDraging] = useState(false);
  const [keyValue, setKeyValue] = useState('');
  const {setFilters} = useContext(MyContext);
  const [filter, setFilter] = useState({});
  const [attrData] = useState({'kqLabel':{
                                            'child':undefined,
                                            'label':'考勤状态',
                                            'list':[
                                                    {'name':'正常','value':'normal'},
                                                    {'name':'迟到','value':'stateLate'},
                                                    {'name':'早退','value':'stateLeaveEarly'},
                                                    {'name':'旷工','value':'stateAbsent'},
                                                    {'name':'请假','value':'stateLeave'}
                                                  ]}
                                          });


  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  //考勤状态
  const kqStatus = (rowData) => {
    const { stateLate,stateAbsent,stateLeaveEarly,leaveCt} = rowData;
    let status = [];
    if(stateLate === 1){
      status.push('迟到');
    }
    if(stateAbsent === 1){
      status.push('旷工');
    }
    if(stateLeaveEarly === 1){
      status.push('早退');
    }
    if(leaveCt > 0){
      status.push('请假');
    }
    return status.join(' | ');
  }

  const getData = async function (page) {
    setLoading(true);
    const { startTime, endTime,kqLabel} = filter;
    const { deptId } = getUser() || {};
    const param = {
      current: page,
      size: pageSize,
      startDate:startTime ? moment(startTime).format("YYYY-MM-DD") : '',
      endDate:endTime ? moment(endTime).format("YYYY-MM-DD") : '',
      orgId:deptId,
      userName: keyValue,
    };
    //考勤状态
    if(kqLabel){
      for(let i=0;i<kqLabel.length;i++){
        switch(kqLabel[i]) {
          case 'normal':
              param.kqStatus = 1;
              break;
          case 'stateLeaveEarly':
              param.stateLeaveEarly = 1;
              break;
          case 'stateAbsent':
              param.stateAbsent = 1;
              break;
          case 'stateLate':
              param.stateLate = 1;
              break;
          case 'stateLeave':
            param.kqStatus = 5;
            break;
          default:
        }
        // if(kqLabel[i]==='normal'){
        //     break;
        // }
      }

    }


    const respActive = await kqEmployeeList(param);
    if (respActive&&respActive.success && respActive.data) {
      let kqEmployeeList = [];
      if (page !== 1) {
        kqEmployeeList = [...data];
      }
      kqEmployeeList = [
        ...kqEmployeeList,
        ...respActive.data.records.map(item => ({
          userName: item.userName,
          kqDate: item.kqDate,
          kqTimeDuring: item.kqTimeDuring,
          stateAbsent:item.stateAbsent,
          stateLate:item.stateLate,
          stateLeaveEarly: item.stateLeaveEarly,
          id: item.id,
          leaveCt: item.leaveCt,
        }))
      ];

      setLoading(false);
      setDraging(false);
      setData(kqEmployeeList);
      setDataSouce(dataSource.cloneWithRows(kqEmployeeList));
      setHasMore(respActive.data.current < respActive.data.pages);
      setIndex(page);
    }
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getData(++pageIndex);
    }
  };

  useEffect(() => {
    getData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, keyValue]);

  useEffect(() => {
    setFilters(
      <Filter
        multiple={true}
        data={attrData}
        handleSearch={(item) => {
          setFilter(item);
        }}
      ></Filter>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attrData]);

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const { userName,kqDate} = rowData;
    const statusStr = kqStatus(rowData);
    return (
      <div className="list-box"
        key={rowID}
      >
        <span className="oatb-list-item-span line-limit-length item">{userName}</span>
        <span className="oatb-list-item-span line-limit-length item">{kqDate}</span>
        <span className="oatb-list-item-span line-limit-length item">{statusStr?<span className='exception'>{statusStr}</span>:'正常'}
        </span>
      </div>
    );
  };
  return (
    <ListView
      ref={listRef}
      dataSource={dataSource}
      initialListSize={pageSize}
      renderHeader={() => <SearchWrapper onChange={setKeyValue} />}
      renderFooter={() => (
        <div style={{ padding: 30, textAlign: 'center' }}>
          {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
        </div>
      )}
      renderBodyComponent={() => <ListWrap />}
      renderRow={row}
      className="active-list-wrap"
      pageSize={pageSize}
      onScroll={() => {
        console.log('scroll');
      }}
      scrollRenderAheadDistance={500}
      onEndReached={onEndReached}
      onEndReachedThreshold={10}
      pullToRefresh={
        <PullToRefresh
          refreshing={draging}
          onRefresh={() => {
            setDraging();
            getData(1);
          }
        }
      />
      }
    />
  );
}

export default KqEmployeeList;
